import React from "react";
import Key from "../Key";
import "./TableNumberBase3.css";

function TableNumberBase3() {
  return (
    <div className="table-number-base-4">
      <div className="overlap-group1-6">
        <div className="field-4">
          <Key />
        </div>
        <div className="line-container-4">
          <img className="bottom-line-4" src="/img/bottom-line-17@2x.png" alt="Bottom Line" />
          <img className="left-line-4" src="/img/left-line-17@2x.png" alt="Left Line" />
          <img className="right-line-4" src="/img/right-line-17@2x.png" alt="Right Line" />
        </div>
      </div>
    </div>
  );
}

export default TableNumberBase3;
